module.exports = __webpack_public_path__ + "static/media/bazinga.app.c826e307.png";